import React from "react";

const PageHeader = ({ title }) => (
  <div>
    <h1 className="font-black text-center tracking-wider text-4xl mt-10 mb-12 md:text-5xl md:mb-20 md:mt-32">
      {title}
    </h1>
  </div>
);

export default PageHeader;
